export class Regexp {
    public static readonly USER_PASSWORD = /^(?=.{10,}$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).*/;
    public static readonly STUDENT_PASSWORD = /^.{4,}$/;
    public static readonly EMAIL = /^(.+)@(.+)$/;
    public static readonly CLASS = /^(\d+)[./](.+)$/;
}
